import EmblaCarousel, { type EmblaOptionsType } from 'embla-carousel'
import Autoplay from 'embla-carousel-autoplay'
import ClassNames from 'embla-carousel-class-names'
import Fade from 'embla-carousel-fade'

const emblaNode = document.querySelector('.embla')
if (emblaNode instanceof HTMLElement) {
  const options: EmblaOptionsType = { loop: true }
  const plugins = [Autoplay({ delay: 5000 }), Fade(), ClassNames()]
  const emblaApi = EmblaCarousel(emblaNode, options, plugins)
}

/**
 * トップページの場合に<html>要素にクラスを付与する
 */
document.addEventListener('DOMContentLoaded', () => {
  // 現在のパスを取得
  const currentPath = window.location.pathname

  // トップページの場合（パスが '/' または '/index.html' の場合）
  if (currentPath === '/' || currentPath === '/index.html') {
    // <html>要素にクラスを追加
    document.documentElement.classList.add('is-top')
  }
})

/**
 * ロード完了時に<html>要素にクラスを付与する
 */
document.addEventListener('DOMContentLoaded', () => {
  document.documentElement.classList.add('is-loaded')
})
